import { render, staticRenderFns } from "./Header-2.vue?vue&type=template&id=4c90e9ec&scoped=true&"
import script from "./Header-2.vue?vue&type=script&lang=js&"
export * from "./Header-2.vue?vue&type=script&lang=js&"
import style0 from "./Header-2.vue?vue&type=style&index=0&id=4c90e9ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c90e9ec",
  null
  
)

export default component.exports